<template>
  <div class="product-notices-sheet">
    <template v-if="!showRulesOnly">
      <!-- 注意事項 -->
      <div v-if="!!product.notices" class="sub-content__block">
        <p class="sheet-title">{{ $t('all_notice') }}</p>

        <div class="sheet-content">
          <ul>
            <li v-for="(str, idx) in splitLineBreaks(product.notices)" :key="idx">
              {{ str }}
            </li>
          </ul>
        </div>

        <v-divider class="sheet__divider" />
      </div>

      <!-- 客戶須知 / 平台規範 -->
      <div v-if="!!product.need_to_know" class="sub-content__block">
        <div class="expansion-panel d-flex justify-space-between align-center" @click="openCustomerNoticeBtn = !openCustomerNoticeBtn">
          <p class="sheet-title">{{ noticeTitle }}</p>

          <v-btn class="mr-4" color="orange50" min-width="32" width="32" height="32" variant="text">
            <funnow-icon class="wd-w-5 wd-h-5" max-width="20" :image-path="`chevron-${openCustomerNoticeBtn ? 'up' : 'down'}_orange.svg`" />
          </v-btn>
        </div>

        <div v-if="openCustomerNoticeBtn" class="sheet-content">
          <ul>
            <li v-for="(str, idx) in splitLineBreaks(product.need_to_know)" :key="idx" :class="{ 'wd-list-none': !str }">
              {{ str }}
            </li>
          </ul>
        </div>

        <v-divider class="sheet__divider" />
      </div>
    </template>

    <!-- 退訂政策 -->
    <div class="sub-content__block">
      <div v-if="!showRulesOnly" class="expansion-panel d-flex justify-space-between align-center" @click="openPolicyBtn = !openPolicyBtn">
        <p class="sheet-title">{{ policyTitle }}</p>

        <v-btn class="mr-4" color="orange50" min-width="32" width="32" height="32" variant="text">
          <funnow-icon class="wd-w-5 wd-h-5" max-width="20" :image-path="`chevron-${openPolicyBtn ? 'up' : 'down'}_orange.svg`" />
        </v-btn>
      </div>

      <div v-if="openPolicyBtn || showRulesOnly" class="sheet-content">
        <template v-if="!isDelivery && rulesPayloads.length">
          <div v-for="(payload, index) in rulesPayloads" :key="payload.label">
            <div class="wd-mb-3" :class="index ? 'wd-mt-5' : ''">{{ $t(payload.label) }}</div>
            <ul>
              <li v-for="rule in payload.rules" :key="rule" class="wd-whitespace-pre-line wd-pb-2">
                <span class="pl-0">{{ rule }}</span>
              </li>
            </ul>
          </div>
        </template>
        <p v-else class="wd-whitespace-pre-line">{{ policyText }}</p>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import FunnowIcon from '@/components/icons/funnow-icon.vue'
import { useMutationPolicies } from '@/composition/useMutationPolicy'
import { useProductFlags } from '@/composition/useProductFlags'
import { usePlatformStore } from '@/store-pinia/platform'
import type { ProductDetailInfo } from '@/view-models/product'

defineOptions({
  name: 'ProductNoticesSheet',
})

interface Props {
  product: ProductDetailInfo
  showRulesOnly?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  product: () => ({} as ProductDetailInfo),
  showRulesOnly: false,
})

const openCustomerNoticeBtn = ref(false)
const openPolicyBtn = ref(false)
const { product } = toRefs(props)

const { t } = useI18n()

const { isFunBookV2 } = storeToRefs(usePlatformStore())

const noticeTitle = computed(() => (isFunBookV2.value ? t('all_customer_notice') : t('all_platform_policy')))

const rescheduleRules = computed(() => product.value.reschedule_rules || [])
const cancelRules = computed(() => product.value.cancel_rules || [])

const { isDelivery } = useProductFlags(product)
const { policyTitle, policyText, rulesPayloads } = useMutationPolicies({
  isDelivery,
  rescheduleRules,
  cancelRules,
})

function splitLineBreaks(str: string | undefined | null): string[] {
  if (!str) {
    return []
  }
  return str.split('\n')
}
</script>
